import React from 'react';
import {
  ContentContainer,
  MainContainer,
  Header,
  Branding,
  Icon,
  NavHeader,
  HeaderNav,
  
  NavLink, SubNav
} from '@tmc/clr-react';
import './App.css';
import { useLocation, Route, Switch } from 'react-router-dom';
import {
  Home,
  MacOs,
  ExcelOnline,
  Ios,
  Windows,
  APIBackendWindows,
  Usage,
  CurrentIssues,
  InstallGuides
} from './Pages';
import { APIBackendMacOs } from './Pages/APIBackendMacOs';
import { getAppInsights } from './TelemetryService';
import TelemetryProvider from './telemetry-provider';
import VMBug from './vmbug.svg';

export const Navigation = (): JSX.Element => {
  const location = useLocation();
  let showSubs = false;
  let menus = ['Usage', 'Current Issues', 'Install Guides'];
  const myArr = menus.map((item, i) => {
    let isActive = false;
    let myLink = '/' + item.replace(/\s/g, '');
    if (location.pathname === myLink) {
      isActive = true;
      if (item === 'Install Guides') {
        showSubs = true;
      }
    } else if (location.pathname !== '/' && location.pathname !== '/Usage' && location.pathname !== '/CurrentIssues') {
      if (item === 'Install Guides') {
        isActive = true;
        showSubs = true;
      }
      
    }
    return <NavLink active={isActive} key={i} href={myLink}>{item}</NavLink>;
  });
  let mySubNavigation;
  if (showSubs) {
    mySubNavigation = <SubNavigation/>;
  } else {
    mySubNavigation = null;
  }
  
  return (
    <><Header color="7">
      <Branding>
        <a href="/" className="nav-link">
          
          <Icon shape='vm-bug'><img
            src={VMBug}
            style={{ height: 36, width: 36 }}
            alt="website logo"
          /></Icon>
          <span className="title">Workspace ONE</span>
        </a>
      </Branding>
      <NavHeader>
        <HeaderNav>
          {myArr}
          {/*<NavLink*/}
          {/*  active*/}
          {/*  href="/Usage"*/}
          {/*  text*/}
          {/*>*/}
          {/*  Usage*/}
          {/*</NavLink>*/}
          
          {/*<NavLink*/}
          {/*  active*/}
          {/*  href="/CurrentIssues"*/}
          {/*  text*/}
          {/*>*/}
          {/*  Current Issues*/}
          {/*</NavLink>*/}
          {/*<NavLink*/}
          {/*  active*/}
          {/*  href="/InstallGuides"*/}
          {/*  text*/}
          {/*>*/}
          {/*  Install Guides*/}
          {/*</NavLink>*/}
        
        </HeaderNav>
      </NavHeader>
    </Header>
      {mySubNavigation}</>
  );
};

export const SubNavigation = (): JSX.Element => {
  const location = useLocation();
  let pages = ['MacOs', 'Windows', 'iOS', 'Excel Online', 'Caching API For Windows', 'Caching API For MacOs'];
  const myArr = pages.map((item, i) => {
    let isActive = false;
    let myLink = '/' + item.replace(/\s/g, '');
    if (location.pathname === myLink) {
      isActive = true;
    }
    
    return <NavLink active={isActive} key={i} href={myLink}><span
      style={{ paddingRight: 3, paddingLeft: 3 }}>{item}</span></NavLink>;
  });
  
  return (
    <SubNav>
      {myArr}
    </SubNav>
  );
};

function App() {
  
  let appInsights = null;
  
  return (
    <MainContainer>
      <TelemetryProvider instrumentationKey="11b8fcaa-6810-4019-b1a9-0ab147e44906" after={() => {
        appInsights = getAppInsights();
      }}>
        <Navigation/>
        {/*<SubNavigation/>*/}
        <ContentContainer>
          <Switch>
            <Route exact path='/' component={Home}/>
            <Route exact path='/MacOs' component={MacOs}/>
            <Route exact path='/Windows' component={Windows}/>
            <Route exact path='/Ios' component={Ios}/>
            <Route exact path='/ExcelOnline' component={ExcelOnline}/>
            <Route exact path='/CurrentIssues' component={CurrentIssues}/>
            <Route exact path='/Usage' component={Usage}/>
            <Route exact path='/CachingAPIForWindows' component={APIBackendWindows}/>
            <Route exact path='/CachingAPIForMacOs' component={APIBackendMacOs}/>
            <Route exact path='/InstallGuides' component={InstallGuides}/>
            
            <Route render={function() {
              return <p>Not found</p>;
            }}/>
          </Switch>
        </ContentContainer>
      </TelemetryProvider>
    </MainContainer>
  );
}

export default App;
